import axios from "axios";
import { Validation } from "../../..";
import { ObservableHandler } from "../../../handlers";
import { parseIdFilter } from "../../../handlers/filter";
import { NotImplementedError, FiltersRequiredError } from "../../../errors";
import { parseNewNewYorkApiResponse } from "../../../utils";
import { isServicePage } from "../../../handlers/page";
import { Observable } from "rxjs";
import { toQueryParams } from "./filters/params";
/**
 * Handles publisher list bundle find.
 * Bundles are version histories of a publisher list, and are thus just an array of Bundles.
 */
class PublisherOrgLevelBundles extends ObservableHandler {
    constructor(sdk) {
        super(sdk, "publisher-bundles");
    }
    /**
     * Find an bundle based on a publisher list id.
     *
     * @param filters: filter publisher bundles from by a given publisher list id (e.g., {where: [field: "id", type: FilterTypes.EQ, value: "1"]}).
     *          Supports (and requires):
     *              {FilterTypes.EQ, "id"}
     */
    findItems(filters) {
        const idFilter = parseIdFilter(filters);
        if (!idFilter) {
            throw new FiltersRequiredError("id");
        }
        return new Observable((subscriber) => {
            this.getBundles(filters)
                .then((bundles) => {
                subscriber.next(bundles);
                subscriber.complete();
            })
                .catch((error) => {
                subscriber.error(error);
            });
        });
    }
    async getBundles(filters = {}) {
        const publisherId = filters.where?.find((filter) => filter.field === "id")
            ?.value;
        if (!publisherId) {
            throw new FiltersRequiredError("publisherId");
        }
        const params = toQueryParams(filters);
        const pageSize = filters?.paging?.size || 10;
        const url = `${this.sdk.urls.baseAPIUrl}/publisher/${publisherId}/bundles${params}`;
        return this.cache.promise(`${url}`, () => axios
            .get(`${url}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
            const rawBundleData = parseNewNewYorkApiResponse(res);
            const results = rawBundleData.data;
            if (isServicePage(rawBundleData)) {
                return {
                    page: {
                        count: rawBundleData.paging_info.count,
                        token: rawBundleData.paging_info.token,
                        size: pageSize
                    },
                    data: rawBundleData.data
                };
            }
            return results;
        })
            .catch((error) => {
            throw error;
        }));
    }
    saveItem(data) {
        return new Observable((subscriber) => {
            const payload = Array.isArray(data) ? data : [data];
            axios
                .patch(`${this.sdk.urls.baseAPIUrl}/bundles`, { data: payload }, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(({ data: res }) => {
                const result = Array.isArray(res.data) ? res.data[0] : res.data;
                this.cache.reconcile("save", result);
                subscriber.next(result);
                subscriber.complete();
            })
                .catch((error) => {
                if (error instanceof Validation) {
                    subscriber.error(new Error(error.values().next().value));
                    return;
                }
                subscriber.error(new Error("Failed to save publisher bundle"));
            });
        });
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    make(bundle) {
        throw new NotImplementedError("make");
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    async deleteItem(id) {
        throw new NotImplementedError("delete");
    }
}
export default PublisherOrgLevelBundles;
//# sourceMappingURL=index.js.map